import {
    FETCH_TEAM_DETAILS,
    FETCH_TEAM_DETAILS_FAIL,
    FETCH_TEAM_DETAILS_SUCCESS
} from './actionTypes';

export const fetchTeamDetails = teamId => ({
    type: FETCH_TEAM_DETAILS,
    payload: teamId
});

export const fetchTeamDetailsSuccess = team => ({
    type: FETCH_TEAM_DETAILS_SUCCESS,
    payload: team
});

export const fetchTeamDetailsFail = error => ({
    type: FETCH_TEAM_DETAILS_FAIL,
    payload: error
});
